export { create as expiringMap } from './expiring-map.js';
export { immutable } from './map.js';
export { mutable } from './map-mutable.js';
export { ofSetMutable } from './map-of-set-mutable.js';
export { ofCircularMutable } from './map-of-circular-mutable.js';
export { NumberMap } from './number-map.js';
export * from './map-multi.js';
//export type { IDictionary as IMappish, IWithEntries } from '../../data/maps/IMappish.js';
